import instance from "@/services/api";

export const residentDictionaryAPI = {
  async read(params) {
    return await instance()
      .get("/handbook/resident_dict/read/", { params })
      .then((res) => res?.data);
  },
  async get(residentId) {
    return await instance()
      .get(`/handbook/resident_dict/${residentId}/get/`)
      .then((res) => res?.data);
  },
  async save(payload) {
    return await instance()
      .post("/handbook/resident_dict/save/", payload, { throwError: true })
      .then((res) => res?.data)
      .catch((error) => {
        // Пробрасываем ошибку дальше, чтобы обработать её в компоненте
        throw error;
      });
  },
  async delete(residentId) {
    return await instance()
      .delete(`/handbook/resident_dict/${residentId}/delete/`)
      .then((res) => res?.data);
  },
  async readClasses() {
    return await instance()
      .get("/handbook/resident_dict/classes/read/")
      .then((res) => res?.data);
  },
  async readCities() {
    return await instance()
      .get("/common/cities/read_city/")
      .then((res) => res?.data);
  },
  async entrancesRead(residentGuid) {
    return await instance()
      .get("/handbook/resident_dict/entrances/read/", { params: { resident_guid: residentGuid } })
      .then((res) => res?.data);
  },
  async entrancesList(residentGuid) {
    return await instance()
      .get("/handbook/resident_dict/entrances/list/", { params: { resident_guid: residentGuid } })
      .then((res) => res?.data);
  },
  async entranceSave(payload) {
    return await instance()
      .post("/handbook/resident_dict/entrance/save/", payload)
      .then((res) => res?.data);
  },
  async entranceDelete(payload) {
    return await instance()
      .post("/handbook/resident_dict/entrance/delete/", payload)
      .then((res) => res?.data);
  },
  async floorDelete(payload) {
    return await instance()
      .post("/handbook/resident_dict/floor/delete/", payload)
      .then((res) => res?.data);
  },
  async entranceCopy(payload) {
    return await instance()
      .post("/handbook/resident_dict/entrance/copy/", payload)
      .then((res) => res?.data);
  },
  async readForBind(residentId) {
    const params = residentId ? { resident_id: residentId } : {};
    return await instance()
      .get("/handbook/resident_dict/read_for_bind/", { params })
      .then((res) => res?.data);
  },
  /** Список ЖК для селекта (resident_id, resident_name), БД: resident__dict_read */
  async readSelect(params = {}) {
    return await instance()
      .get("/handbook/resident_dict/read_select/", { params })
      .then((res) => res?.data);
  },
};

